<template>
    <div class="emptyList" :style="this.$props.styles">
        <van-image 
            width="180"
            height="140"
            :src="require('@/assets/img/empty.png')"
        />
        <p>{{text}}</p>
    </div>
</template>

<script>
export default {
    props: {
        styles: {
            type: [Object],
            default: () => {}
        },
        text: {
            type: [String],
            default: '没有发现任何东西..'
        }
    }
}
</script>

<style lang="less" scoped>
    .emptyList {
        width: 100%;
        padding-top: 100px;
        padding-bottom: 20px;
        text-align: center;
        background-color: #fff;
        p {
            font-size:14px;
            font-weight:400;
            color:rgba(100,100,100,1);
            margin-top: 20px
        }
    }
</style>